import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { APP_PATHS } from '../app.paths';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const dialog = inject(MatDialog, { optional: true });
  const injector = inject(Injector);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Check if the request explicitly asked to skip the error interceptor
        if (req.headers.has('X-Skip-Error-Interceptor')) {
          return throwError(() => error);
        }

        // Close all open dialogs (e.g. settings, playlist selection)
        dialog?.closeAll();

        // Don't redirect to login if we're already on the login page
        // (e.g., failed login attempt should just show error, not redirect)
        const currentUrl = router.url.split('?')[0]; // Get path without query params
        if (currentUrl === `/${APP_PATHS.LOGIN}`) {
          return throwError(() => error);
        }

        // We use clearSession() instead of logout() because logout() triggers another HTTP request
        // which might fail or loop. We just want to clear local state.
        // We use Injector to get AuthService lazily to avoid a circular dependency
        // (AuthService -> HttpClient -> ErrorInterceptor -> AuthService).
        const authService = injector.get(AuthService);
        authService.clearSession();

        router.navigate(['/', APP_PATHS.LOGIN], {
          queryParams: { redirect: router.url },
        });
      }
      return throwError(() => error);
    }),
  );
};
